import { useEffect, useState } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { useField } from '@unform/core';


type TVTextFieldProps = TextFieldProps & {
  name: string;//nome do campo
}
export const VTextField: React.FC<TVTextFieldProps> = ({ name, ...rest }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField(name);

  const [value, setValue] = useState(defaultValue || '');// state sempre inicializar com algum valor caso seja cadastro


  useEffect(() => {
    registerField({
      name: fieldName,// nome do campo
      getValue: () => value,
      setValue: (_, newValue) => setValue(newValue),
    });
  }, [registerField, fieldName, value]);


  return (
    <TextField
      {...rest}// resto das possiveis props do textfield

      error={!!error}//  se tiver algum erro
      helperText={error}// mostra o helptext
      defaultValue={defaultValue}

      value={value ?? ''}
      onChange={e => setValue(e.target.value)}

      onKeyDown={() => error ? clearError() : undefined}// limpar o erro ao usuario digitar
    />
  );
};